"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ComponentFABPage"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFABPage/index.ts
// module id = 667
// module chunks = 0